<mat-chip-list>
	<mat-chip *ngFor="let item of items">{{item}}</mat-chip>
</mat-chip-list>
